import { Box, Grid, IconButton, Typography } from '@mui/material';

import { FORTA_BLUE, FORTA_WHITE } from '../../../../../utils/colors';
import DeleteIcon from '../../../../svgs/DeleteIcon';
import { useClientSupervisionEditable } from '../../../../../hooks';

import type { ITargetPhase } from '../../../../../utils/types';

interface DataTableProps {
  data: ITargetPhase[];
  onDelete: (id: number) => void;
}

function DataTable(props: DataTableProps) {
  const { data, onDelete } = props;
  const isEditable = useClientSupervisionEditable();

  return (
    <Box sx={{ borderRadius: '4px', backgroundColor: FORTA_WHITE }}>
      <Grid
        container
        sx={{
          backgroundColor: FORTA_BLUE.primary,
          height: 40,
          borderRadius: '4px 4px 0 0',
          alignItems: 'center',
          color: FORTA_WHITE,
        }}
      >
        <Grid item xs={3} sx={{ display: 'flex' }}>
          <Box
            sx={{ display: 'flex', justifyContent: 'flex-start', width: 40, height: 20, ml: 2 }}
          ></Box>
          <Typography fontWeight="bold" flexGrow={1}>
            Goal
          </Typography>
        </Grid>
        <Grid item xs={3}>
          <Typography fontWeight="bold">Target</Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography fontWeight="bold">Title</Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography fontWeight="bold">Date</Typography>
        </Grid>
      </Grid>
      <Grid container>
        {data.map((item: ITargetPhase) => (
          <Grid item xs={12} key={item.id}>
            <Grid
              container
              sx={{
                minHeight: 40,
                alignItems: 'center',
              }}
            >
              <Grid item xs={3} sx={{ display: 'flex' }}>
                <Box sx={{ display: 'flex', justifyContent: 'flex-start', width: 40, ml: 2 }}>
                  <IconButton
                    sx={{ p: 0 }}
                    disabled={!isEditable}
                    onClick={() => {
                      if (item.id !== undefined) onDelete(item.id);
                    }}
                  >
                    <DeleteIcon />
                  </IconButton>
                </Box>
                <Typography flexGrow={1}>{item?.goal_name}</Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography>{item?.target_name}</Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography>{item?.title}</Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography>{item?.date_added}</Typography>
              </Grid>
            </Grid>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}

export default DataTable;
